<template>
    <div>
        <t-loader :loading="isBusy"></t-loader>
        <div class="card">
            <div class="card-header">
                Services
                <br>
                <small>Available services for user</small>
            </div>
            <div class="card-body">
                <b-table
                        show-empty
                        :responsive="true"
                        :items="myProvider"
                        :busy.sync="isBusy"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        ref="table"
                >
                    <template v-slot:cell(allowed)="data">
                        <toggle-button on-label="Yes" off-label="No"
                                       :value="data.item.allowed" field_name="allowed"
                                       :route="data.item.route" :requireConfirmation="true"
                                       confirmationText="Connection allowance will be updated to: [value]">
                        </toggle-button>
                    </template>
                    <template v-slot:cell(active)="data">
                        <toggle-button on-label="Active" off-label="Disabled"
                                       :value="data.item.active" field_name="active"
                                       :route="data.item.route" :requireConfirmation="true"
                                        confirmationText="Service status will be updated to: [value]">
                        </toggle-button>
                    </template>
                </b-table>
                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="my-table"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'ServiceIntegrationTable',
    props: {
      user_id: {
        type: Number,
      },
    },
    data() {
      return {
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        services: [],
        isBusy: false,
        defaultFields: [
          {key: 'name', label: 'Name'},
          {key: 'allowed', label: 'Connection allowed'},
          {key: 'active', label: 'Service status'},
        ],
      };
    },
    computed: {
      fields() {
        return this.defaultFields;
      },
    },
    methods: {
      myProvider(ctx) {
        const url = `/users/${this.user_id}/services?page=${ctx.currentPage}&size=${ctx.perPage}`;
        let promise = axios.get(url);

        return promise.then((response) => {
          const data = response.data.data;
          const meta = response.data.meta;
          this.currentPage = meta.current_page;
          this.totalRows = meta.total;
          this.services = data || [];

          return this.services;
        }).catch(error => {
          return [];
        });
      },
      refresh() {
        this.$nextTick(() => {
          this.$refs.table.refresh();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
